import { fetcher } from '@commenda/utils';

import { IIndirectTaxFilingV2MutationResult } from './types';

export async function deleteIndirectTaxFilingV2({
  filingId,
  corporationId,
  token,
}: {
  filingId: string;
  corporationId: number;
  token?: string;
}): Promise<IIndirectTaxFilingV2MutationResult<undefined>> {
  try {
    const response = await fetcher(
      `new-sales-tax/filings-v2/${filingId}?corporationId=${corporationId}`,
      { method: 'DELETE' },
      token
    );
    if (!response.ok) {
      const json = await response.json().catch(() => null);
      return {
        success: false,
        error: json?.message || 'Failed to delete filing',
      };
    }
    return { success: true };
  } catch (error) {
    return {
      success: false,
      error:
        error instanceof Error ? error.message : 'Failed to delete filing',
    };
  }
}
